(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  /* Cambio automático de colores según tema */
  const marquee = document.querySelector('#section-{{ section.id }} .tm-wrap');
  if(marquee){
    const theme = "{{ section.settings.theme }}";
    if(theme === "lime"){
      marquee.style.setProperty('--border', '#a6ff00');
      marquee.style.setProperty('--glow', '#a6ff00');
    }
    if(theme === "berries"){
      marquee.style.setProperty('--border', '#a100ff');
      marquee.style.setProperty('--glow', '#a100ff');
    }
  }

  /* FIX MÓVIL: medir altura del header y usarla como offset bajo la barra */
  (function(){
    const mq = window.matchMedia('(max-width: 640px)');
    if(!mq.matches) return; // no tocar desktop

    const header =
      document.querySelector('.shopify-section-header-sticky') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('.site-header');

    if(header){
      const h = header.offsetHeight || 64;
      document.documentElement.style.setProperty('--header-h', h + 'px');
    }
  })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
